module.exports = __webpack_public_path__ + "static/media/train.625926d3.jpg";